import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData } from "components/pages/LoginPage";
import "./styles.css";

/**
 * @function CaptureChatLogIn
 * @return {React.Component}
 * @exported true
 * @description Capture component for "007_Chat_Log_In".
 */
export default function CaptureChatLogIn(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "userID" ], "GeorgeW")
        .update([ "password" ], "123456789012")
        .submit();

    return <div className="chat-log-in-007"><LoginPage data={ data } /></div>
}